import type { BrowserOptions } from '@sentry/react';
import * as Sentry from '@sentry/react';
import { browserTracingIntegration } from '@sentry/browser';
// @ts-ignore
import appVersion from '!!raw-loader!../app-version';

const WASM_REDACTED = 'data:application/wasm;(REPLACED_MANUALLY_FOR_MEMORY_SAVE)';

export const initSentry = () => {
    if (window.location.hostname === 'localhost') {
        return;
    }

    if (Sentry.getClient()?.getOptions().dsn === SENTRY_DSN) {
        return;
    }

    Sentry.init({
        environment: ENVIRONMENT,
        release: `studio@${appVersion}`,
        dist: appVersion,
        dsn: SENTRY_DSN,
        autoSessionTracking: true,
        integrations: [browserTracingIntegration(), Sentry.captureConsoleIntegration({ levels: ['error'] })],
        tracesSampleRate: 1.0,
        beforeSend(event) {
            event.breadcrumbs?.forEach((breadcrumb) => {
                if (breadcrumb.category === 'fetch' && breadcrumb.data?.url?.includes('data:application/wasm;')) {
                    breadcrumb.data.url = WASM_REDACTED;
                }
            });

            return event;
        },
        beforeSendSpan(span) {
            const httpUrl = span.data?.['http.url'] as string | undefined;

            if (span.op === 'http.client' && httpUrl?.includes('data:application/wasm;base64')) {
                span.data = {
                    ...span.data,
                    url: WASM_REDACTED,
                    'http.url': WASM_REDACTED,
                };
            }

            return span;
        },
    } as BrowserOptions);
};
